import Request from './core';

export default Request;
